import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "10px 20px 20px 20px",
    boxSizing: "border-box",
    overflowX: "auto",
    overflowY: "auto",
    backgroundColor: "#fff",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "15px",
    borderBottom: "1px solid #e0e0e0",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#000",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginLeft: "20px",
  },
  productInfo: {
    marginBottom: "20px",
    paddingBottom: "15px",
    borderBottom: "1px solid #e0e0e0",
    display: "flex",
    gap: "30px",
    alignItems: "flex-start",
  },
  productInfoItem: {
    display: "flex",
    flexDirection: "column",
  },
  productInfoLabel: {
    fontSize: "16px",
    color: "#000",
    marginBottom: "4px",
    fontWeight: 600,
  },
  productInfoValue: {
    fontSize: "14px",
    color: "#000",
    fontWeight: 400,
    [theme.breakpoints.up(1680)]: {
      fontSize: "16px",
    },
  },
  filterSection: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    flexWrap: "wrap",
    gap: "10px",
  },
  filterLeft: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    flexWrap: "wrap",
    flex: 1,
    minWidth: 0,
  },
  viewByGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  viewByLabel: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#000",
  },
  clearFilters: {
    color: "#2196F3",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "0.875rem",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  filterRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "2px",
    flexShrink: 0,
    minWidth: "200px",
  },
  searchInput: {
    width: "400px",
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid #e0e0e0',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: '1px solid #000',
    },
    '& .MuiInput-underline:after': {
      borderBottom: '2px solid #000',
    },
  },
  refreshContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "2px",
    [theme.breakpoints.down('sm')]: {
      justifyContent: "flex-start",
      paddingTop: "1rem",
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: "1rem",
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  refreshText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  perPageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  formPerPage: {
    minWidth: '60px',
    height: '32px',
    '& .MuiOutlinedInput-root': {
      outline: 'none !important',
      '&.Mui-focused': {
        outline: 'none !important',
        '& fieldset': {
          borderWidth: '1px !important',
        },
      },
    },
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '& .Mui-focused fieldset': {
      borderColor: '#000 !important',
    },
    '& .MuiSelect-select': {
      padding: '6px 14px',
    },
    '& .MuiSelect-icon': {
      color: '#666',
    },
  },
  outlined: {
    padding: '6px 14px',
  },
  searchButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '8px 24px',
    minWidth: '120px',
    minHeight: '40px',
    height: '40px',
    boxShadow: 'none',
    fontWeight: 500,
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#d4551a',
    },
  },
  messagesContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
}));

